/* eslint-disable */ import { assertNumber, attributeSelectionComponent, distanceDimensionComponent, genericDimensionComponent, memoEval, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kickPlateBulkOrderItemComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(distanceDimensionComponent, 'horizontalLength', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((self)=>[
            self.$horizontalLengthMin,
            self.$horizontalLengthMax,
            self.horizontalLength
        ], ($horizontalLengthMin, $horizontalLengthMax, horizontalLength)=>({
            min: $horizontalLengthMin,
            max: $horizontalLengthMax,
            value: horizontalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'verticalLength', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((self)=>[
            self.$verticalLengthMin,
            self.$verticalLengthMax,
            self.verticalLength
        ], ($verticalLengthMin, $verticalLengthMax, verticalLength)=>({
            min: $verticalLengthMin,
            max: $verticalLengthMax,
            value: verticalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalLength: state.value
        };
    }),
    attachComponent.withComponent(genericDimensionComponent, 'quantity', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((self)=>[
            self.quantity
        ], (quantity)=>({
            min: 1,
            max: 10000,
            unit: 'pcs',
            value: quantity
        })), (state)=>{
        return {
            quantity: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'horizontalHoleCount', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((self)=>[
            self.horizontalHoleCount,
            self.$availableHorizontalHoleCountOptions
        ], (horizontalHoleCount, $availableHorizontalHoleCountOptions)=>({
            value: horizontalHoleCount,
            options: $availableHorizontalHoleCountOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalHoleCount: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'verticalHoleCount', true).withEntity('KickPlateBulkOrderItem').attach(memoEval((self)=>[
            self.verticalHoleCount,
            self.$availableVerticalHoleCountOptions
        ], (verticalHoleCount, $availableVerticalHoleCountOptions)=>({
            value: verticalHoleCount,
            options: $availableVerticalHoleCountOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalHoleCount: state.value
        };
    })
];

//# sourceMappingURL=kick-plate-bulk-order-item.js.map